import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Expedition 33 Any% Restricted" mdxType="SEO" />
    <h1 {...{
      "id": "clair-obscur-expedition-33-any-restricted"
    }}>{`Clair Obscur: Expedition 33 Any% Restricted`}</h1>
    <h3 {...{
      "id": "notation"
    }}>{`Notation`}</h3>
    <p>{`For menus, I will sometimes have something in parenthesis. If it's (S1-3), it refers to the slot the Picto should be placed in. If it's a Playstation controller button, it's a button you should press to optimize the menu.`}</p>
    <p>{`For battles, there will sometimes be something like (1.1 QTE). This refers to the Quick Time Action you do when you use an Ability. A perfect is 1.2, a normal is 1.1, and a fail is 1.0. The number refers to the damage multiplier the skill gets from the QTE.`}</p>
    <p>{`For loading saves, I will use notation like load S0 to load the top save, or S2 to load the 3rd save (2 down).`}<br parentName="p"></br>{`
`}{`These will assume no mistakes, since mistakes will often lead to extra saves. The notes will still describe which save to load.`}</p>
    <p>{`There's also a debug reload you can do by pressing Alt+V. I will refer to this as `}<strong parentName="p">{`Debug Load`}</strong>{`. You generally have to mash it as you enter an area, exit a menu, or load screen is ending.`}</p>
    <hr></hr>
    <p>{`You can check the changelog at the bottom of the notes.`}</p>
    <p>{`These are my personal notes for the category, the writing will reflect that. For the most part these notes will not say where to go or where things are, just what to do. I will be updating these as the route progresses, changes will be reflected in the changelog at the bottom of the notes.`}</p>
    <p>{`There will also be enemy data and maybe some other useful information at the bottom of the notes.`}</p>
    <p>{`If there's a time listed by a fight, it's my best time for it so far. It does not represent the average.`}</p>
    <h2 {...{
      "id": "prologue"
    }}>{`Prologue`}</h2>
    <p>{`Do Windmill skip. The notes will assume you do it, but will note small changes if you fight Maelle where applicable.`}<br parentName="p"></br>{`
`}{`If you're learning, don't bother with Windmill and just fight Maelle.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "maelle-450hp"
      }}>{`Maelle 450HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1XP, $50, Colour of Lumina`}</p>
      </blockquote>
      <p>{`Attack > Parry > 3 Shots (2 if 1 head), Attack > Parry`}</p>
    </Battle>
    <h3 {...{
      "id": "harbor"
    }}>{`Harbor`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Maelle, skip Maelle duel`}</li>
      <li parentName="ul">{`Talk to Aprentices`}</li>
      <li parentName="ul">{`Talk to Emma`}</li>
    </ul>
    <p>{`4 CS on Transition`}</p>
    <h2 {...{
      "id": "act-i"
    }}>{`Act I`}</h2>
    <h3 {...{
      "id": "spring-meadows"
    }}>{`Spring Meadows`}</h3>
    <Menu timing="Cutscene entering Lancelier or Portier" mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Lumiere Assault Left-Bottom`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lancelier-122hp-6xp-50-010"
      }}>{`Lancelier 122HP 6XP $50 (0:10)`}</h4>
      <ul>
        <li parentName="ul">{`Shoot twice, Attack > Parry`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "portier-450hp-008"
      }}>{`Portier 450HP (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`10XP, $75, Dodger + 0-2 Chroma Catalyst `}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spot + 1 shot, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
    </Battle>
    <p>{`Pick up `}<strong parentName="p">{`Critical Burn`}</strong>{`. Can do house skip to save ~1s. Don't need the pickups.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "3-volester-81hp-017"
      }}>{`3 Volester 81HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`43XP, $216, 0-2 Chroma Catalyst?`}<br parentName="p"></br>{`
`}{`Parry timing is on slowdown/freeze frames on both of their attacks`}</p>
      </blockquote>
      <p>{`Parry both attacks. Shoot last one to death. Requires 5AP.`}</p>
    </Battle>
    <Menu timing="During journal cutscene" mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <p>{`-+Gustave`}</p>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+(S3) Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Dead Energy II`}</strong>{`.`}</p>
    <Menu timing="Flag before Eveque" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +6 Might (6)`}</li>
        <li parentName="ul">{`Lune: +6 Might (6)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Eveque battle" mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Dead Energy II`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "eveque-139"
      }}>{`Eveque (1:39)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$862, Cleansing Tint, 5 Chroma Catalyst, 0-2 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot off shields (last shield shoot weakpoint), Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Lumiere Assault`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Gustave / Ice Lance / Attack`}</li>
        <li parentName="ul">{`Gustav: Can shoot till 4AP, Overcharge`}</li>
      </ul>
      <p>{`If not dead, shoot off shields and damage as best as you can.`}</p>
    </Battle>
    <h3 {...{
      "id": "continent"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp before entering Flying Waters`}</p>
    <h3 {...{
      "id": "flying-waters"
    }}>{`Flying Waters`}</h3>
    <Menu timing="Cutscenes entering Flying Waters or Manor" mdxType="Menu">
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: -Lumiere Assault`}</li>
      </ul>
      <h5 {...{
        "id": "weapons"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim`}</li>
      </ul>
    </Menu>
    <p>{`Once Manor is in view, `}<strong parentName="p">{`Picto Save`}</strong>{` and `}<strong parentName="p">{`Debug Load`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Optionally, `}</p>
    <p>{`Menu during the cutscene where you enter Maelle's room.`}</p>
    <Menu timing="Getting Maelle" mdxType="Menu">
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: -Spark`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-2"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`After getting Maelle, reload the manor autosave (Top+1)`}<br parentName="p"></br>{`
`}{`After talking to door, open menu as screen is fading out and load most recent autosave.`}</p>
    <p>{`Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-1"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +1 Might (7), +5 Agility (5)`}</li>
        <li parentName="ul">{`Maelle: +15 Might (15)`}</li>
        <li parentName="ul">{`Lune: +3 Might (9), +3 Agility (3)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +Marking Shot`}</li>
        <li parentName="ul">{`Maelle: +Swift Stride`}</li>
        <li parentName="ul">{`Lune: +Rockslide`}</li>
      </ul>
    </Menu>
    <p>{`Do `}<strong parentName="p">{`Goblu Skip`}</strong></p>
    <h3 {...{
      "id": "camp"
    }}>{`Camp`}</h3>
    <Menu timing="Talk to Curator" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <p><strong parentName="p">{`Debug Load`}</strong>{` and upgrade weapon before the load happens.`}</p>
      <ul>
        <li parentName="ul">{`Maelle: Maellum +1 (3)`}</li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Debug Load`}</strong>{` after game loads. Want to do it after the "stars" dissappear from the loading screen.`}<br parentName="p"></br>{`
`}{`You should see the game save and instantly load afterwards.`}</p>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-1"
    }}>{`Continent`}</h3>
    <h3 {...{
      "id": "esquies-nest"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Password Skip`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "francois-035"
      }}>{`Francois (0:35)`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot 2 times (3 if Lune target), Immolation`}</li>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <p>{`Counter if Maelle target for crit safety.`}</p>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, counter until 800 counter damage.`}</p>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Gustave if 0AP, else skip`}</li>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Battle>
    <p>{`Menu during Esquie's cutscene.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills-3"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Rockslide Bottom-Left`}</li>
      </ul>
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <p>{`-+Lune`}</p>
    </Menu>
    <p>{`After talking to Esquie cutscene, load autosave outside Flying Waters (Top + 1).`}<br parentName="p"></br>{`
`}{`Go to Flying Waters entrance, then reload most recent autosave and mash to enter Flying Waters.`}</p>
    <p>{`Watch load screen, once the "stars" disappear mash `}<strong parentName="p">{`Debug Load`}</strong>{` to reload save to setup dupe'd save.`}<br parentName="p"></br>{`
`}{`Then exit Flying Waters.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This save will be loaded during OL skip, should be 3s gap between saves.`}</p>
    </blockquote>
    <h3 {...{
      "id": "continent-2"
    }}>{`Continent`}</h3>
    <p>{`Camp right away.`}</p>
    <h3 {...{
      "id": "camp-1"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-3"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Stone Wave Cliffs`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stone-wave-cliffs"
    }}>{`Stone Wave Cliffs`}</h3>
    <p>{`Menu during first cutscene.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-3"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+(S1) Cleansing Tint`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p><strong parentName="p">{`Picto save`}</strong>{` for Delaram warp.`}</p>
    <p>{`Unlock Paint Cage, reload autosave and pick up `}<strong parentName="p">{`Delaram`}</strong>{` during the load.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`First Strike`}</strong>{`.`}</p>
    <Menu timing="Jump down from First Strike" mdxType="Menu">
      <h5 {...{
        "id": "pictos-4"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +(S1) First Strike`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`SOS Power`}</strong>{`.`}</p>
    <Menu timing="Jump at start of Farm" mdxType="Menu">
      <h5 {...{
        "id": "pictos-5"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +SOS Power`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`If 2 Francois Polished drops, can pick up `}<strong parentName="p">{`Polished Chroma Catalyst`}</strong>{`.`}</p>
    </blockquote>
    <p>{`Pick up `}<strong parentName="p">{`Duenum`}</strong>{`.`}</p>
    <p>{`Do Cave skip and pick up `}<strong parentName="p">{`Coralim`}</strong>{`.`}</p>
    <Menu timing="Flag before Lampmaster" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-2"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: +6 Might (13)`}</li>
        <li parentName="ul">{`Maelle: +3 Might (18)`}</li>
        <li parentName="ul">{`Lune: +6 Might (15)`}</li>
      </ul>
    </Menu>
    <Menu timing="Lampmaster cutscene" mdxType="Menu">
      <h5 {...{
        "id": "weapons-1"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Delaram`}</li>
        <li parentName="ul">{`Maelle: Duenum`}</li>
        <li parentName="ul">{`Lune: Coralim`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`This fight is pretty dynamic, so practice is recommended here.`}</p>
      </blockquote>
      <h4 {...{
        "id": "lampmaster-216"
      }}>{`Lampmaster (2:16)`}</h4>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Energy Tint Lune`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
        <li parentName="ul">{`Lune: Rockslide`}</li>
      </ul>
      <p>{`Want him to survive here with as little HP as possible.`}</p>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Powerful`}</li>
        <li parentName="ul">{`Maelle: Skip`}</li>
        <li parentName="ul">{`Lune: Skip / Attack / Ice Lance if damage needed`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Overcharge / Marking Shot if enough damage`}</li>
      </ul>
      <h4 {...{
        "id": "phase-2"
      }}>{`Phase 2`}</h4>
      <h5 {...{
        "id": "turn-45"
      }}>{`Turn 4.5`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Offensive Switch`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
        <li parentName="ul">{`Lune: Rockslide`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
    </Battle>
    <h2 {...{
      "id": "act-ii"
    }}>{`Act II`}</h2>
    <h3 {...{
      "id": "camp-2"
    }}>{`Camp`}</h3>
    <p>{`Go to Curator, can equip Delaram before for easier upgrade menu (will need to re-equip).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-1"
      }}>{`Upgrade Weapons`}</h5>
      <p><strong parentName="p">{`Debug Load`}</strong>{` and upgrade weapon before the load happens.`}</p>
      <ul>
        <li parentName="ul">{`Verso: Delaram +1 (8)`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu timing="Before Battlefield" mdxType="Menu">
      <h5 {...{
        "id": "weapons-2"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
    </Menu>
    <Menu timing="Camp flag" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-3"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +7 Might (22)`}</li>
        <li parentName="ul">{`Verso: +33 Might`}</li>
        <li parentName="ul">{`Maelle: +15 Might (33)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Rain of Fire`}</li>
        <li parentName="ul">{`Verso: +Powerful, +Berserk Slash (Left-Top)`}</li>
      </ul>
    </Menu>
    <p>{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-4"
    }}>{`Continent`}</h3>
    <p>{`As soon as you have control, `}<strong parentName="p">{`Go to Camp`}</strong>{` and `}<strong parentName="p">{`Debug Load`}</strong>{`.`}</p>
    <Menu timing="As soon as you get on land before Battlefield" mdxType="Menu">
      <h5 {...{
        "id": "pictos-6"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike > First Strike (Swap)`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+SOS Power > Dodger (No Swap)`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "forgotten-battlefield"
    }}>{`Forgotten Battlefield`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chalier"
      }}>{`Chalier`}</h4>
      <ul>
        <li parentName="ul">{`Counter 1st hit`}</li>
        <li parentName="ul">{`Maelle: Offensive Switch`}</li>
      </ul>
      <p>{`Let Verso die to the Gradient`}</p>
      <ul>
        <li parentName="ul">{`Lune: Shots if needed, Immolation`}</li>
        <li parentName="ul">{`Maelle: Shots if needed, Rain of Fire`}</li>
      </ul>
    </Battle>
    <p>{`Exit Forgotten Battlefield right away.`}</p>
    <h3 {...{
      "id": "continent-5"
    }}>{`Continent`}</h3>
    <blockquote>
      <p parentName="blockquote">{`We're gonna use a new term here, Esquie Debug Load Mount Storage, or `}<strong parentName="p">{`EDLMS`}</strong>{`. You can load a save, `}<strong parentName="p">{`Debug Load`}</strong>{` as it loads in, and mount/dismount Esquie to transfer mount state to your S0 save.`}</p>
    </blockquote>
    <p>{`Start Battlefield skip.`}</p>
    <Menu timing="Once positioned for BF Skip" mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <p>{`-Lune`}</p>
      <h5 {...{
        "id": "pictos-7"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: -At Death's Door`}</li>
      </ul>
    </Menu>
    <p>{`Load S1, `}<strong parentName="p">{`EDLMS`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to 2nd spot for Battlefield skip. `}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-8"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +(L2) Dead Energy II`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`This is recommended if you're not comfortable with the route yet. Moves the Flying Waters save up, letting you make more mistakes without losing it.`}<br parentName="p"></br>{`
`}{`Run into Flying Waters trigger (want to get bit deep into it, so Esquie is mountable). Picto save, while game is saving open save menu and load S2. Back out, open and close menu quickly, and mount Esquie `}<strong parentName="p">{`using Z on keyboard`}</strong>{`. Use Z for any `}<strong parentName="p">{`ELDMS`}</strong>{` using this save afterwards. Ignore line below if doing this.`}</p>
    </blockquote>
    <p>{`Load save outside Flying Waters, `}<strong parentName="p">{`ELDMS`}</strong>{`.`}</p>
    <p>{`Finish Battlefield skip.`}</p>
    <p>{`Go to fight ahead of Battlefield entrance and preempt it.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chalier-cruler-bruler"
      }}>{`Chalier, Cruler, Bruler?`}</h4>
      <ul>
        <li parentName="ul">{`Flee`}</li>
      </ul>
    </Battle>
    <Menu timing="Before Troubadour fight" mdxType="Menu">
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <p>{`+Lune`}</p>
    </Menu>
    <p>{`Go to fight by Monoco Station entrance.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "demineur-troubador-gault-008"
      }}>{`Demineur, Troubador, Gault (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`8268XP, $988, Troubadim LV8 + Gaulteram LV8 + 0-1? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-1"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`Shoot Mine then shoot Demineur once.`}</li>
            <li parentName="ul">{`Shoot Troubadour weakness 3 times`}</li>
            <li parentName="ul">{`Berserk Slash Gault`}</li>
          </ul></li>
      </ul>
    </Battle>
    <p>{`Go to invisible bridge, Picto save & reload (can `}<strong parentName="p">{`Debug Load`}</strong>{`).`}<br parentName="p"></br>{`
`}{`Do Monoco Station skip.`}</p>
    <h4 {...{
      "id": "old-lumiere-skip"
    }}>{`Old Lumiere Skip`}</h4>
    <p>{`Picto save anywhere along the way to the building where you can mount & dismount Esquie.`}</p>
    <p>{`Climb up building. Picto save, and load S1. `}<strong parentName="p">{`EDLMS`}</strong>{`.`}</p>
    <p>{`Go to cliff edge for Esquie mount. Picto save, and load Flying Waters save. `}<strong parentName="p">{`ELDMS`}</strong>{`.`}</p>
    <p>{`Run up mountain, get onto building past railing. Picto save, `}<strong parentName="p">{`Load S3`}</strong>{`. `}<strong parentName="p">{`EDLMS`}</strong>{`.`}</p>
    <p>{`Run off the building on the left side. Run on invisible ground to the left over the water, and climb onto mountain in front. Picto save, and load Flying Waters save. `}<strong parentName="p">{`EDLMS`}</strong>{`.`}</p>
    <p>{`Ride Esquie past the trees and off into the water. There's a part of the ground that protrudes out like a dock.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Visages`}</strong>{`.`}</p>
    <h3 {...{
      "id": "visages"
    }}>{`Visages`}</h3>
    <Menu timing="During cutscene at start" mdxType="Menu">
      <h5 {...{
        "id": "pictos-9"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`-Augmented First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Cleansing Tint`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+SOS Power`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to Joy Mask.`}</p>
    <Menu timing="Cutscene entering Joy Mask" mdxType="Menu">
      <h5 {...{
        "id": "skills-4"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire Left-Middle, Remove Slot 4`}</li>
        <li parentName="ul">{`Verso: Remove Slot 2 & 3`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`This is optional, guarantees counter kills Jovial Moissoneusse if Verso 0 crits.`}</p>
      </blockquote>
      <h5 {...{
        "id": "weapons-3"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Troubadim`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Confident Fighter`}</strong>{`.`}</p>
    <Menu timing="Jump down to Joy Mask" mdxType="Menu">
      <h5 {...{
        "id": "pictos-10"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso: +Confident Fighter`}</li>
      </ul>
    </Menu>
    <p>{`Go to Joy Mask, Option 1 to take Fight.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "chapelier-moissoneusse-bouchelier-021"
      }}>{`Chapelier, Moissoneusse, Bouchelier (0:21)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`76284XP, $3822, Chapelim LV11, 1-3 Resplendant`}<br parentName="p"></br>{`
`}{`Keep an eye for Resplendant drops, if more than 1 can skip pickup in Monolith.`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You need 1 crit on both the Chapelier and Moissoneusse. If you don't get the Chapelier one, reload your most recent save. If no crit on Moissoneusse, any counter will kill except Lune with Coralim.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-2"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Shoot Chapelier's `}<strong parentName="li">{`HEAD`}</strong>{` 3 times. Berserk Slash Moissoneusse.`}</li>
      </ul>
      <p>{`Bouchelier will do something, only counter if Gradient.`}</p>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Shoot off shields from Bouchelier, skip.`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Battle>
    <p>{`Go to Visages.`}</p>
    <Menu timing="Flag before Visages" mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Recoat, +Storm Caller`}</li>
        <li parentName="ul">{`Verso: +Defiant Strike, +Leadership`}</li>
      </ul>
    </Menu>
    <p>{`Menu and `}<strong parentName="p">{`debug load`}</strong>{` on menu exit.`}</p>
    <Menu timing="After auto save point after final grapple" mdxType="Menu">
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <p>{`Equip Chapelim (Go to inventory and mash confirm)`}</p>
    </Menu>
    <Menu timing="Entering Mask Keeper fight" mdxType="Menu">
      <h5 {...{
        "id": "pictos-11"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+(R3) SOS Power`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "visages-129"
      }}>{`Visages (1:29)`}</h4>
      <h5 {...{
        "id": "turn-0-3"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Offensive Switch`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <p>{`Counter all 3 moves.`}</p>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Storm Caller`}</li>
      </ul>
      <p>{`Should die to Storm Caller after 3rd counter.`}</p>
    </Battle>
    <h3 {...{
      "id": "camp-3"
    }}>{`Camp`}</h3>
    <p>{`Go to sleep.`}</p>
    <p>{`When you reach Monolith entrance, load S1 (save from Camp) and enter Monolith.`}</p>
    <h3 {...{
      "id": "monolith"
    }}>{`Monolith`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-4"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Luck +35 (35)`}</li>
        <li parentName="ul">{`Verso: Might +27 (60)`}</li>
        <li parentName="ul">{`Maelle: Agility +27 (27)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-4"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Wildfire, Equip Left-Bottom`}</li>
        <li parentName="ul">{`Maelle: +Last Chance, Equip Left-Bottom (Optional)`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene before Feetress" mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Formation might be better done on a jump`}</p>
      </blockquote>
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <p>{`-Maelle`}</p>
      <h5 {...{
        "id": "pictos-12"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`(Triangle) +Immaculate > Augmented First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Confident Fighter`}</li>
            <li parentName="ul">{`-First Strike`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-3"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`-Dead Energy II`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
          </ul></li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`When the battle is loading, you can press back twice. This will keep the menu open but combat inputs will still work properly. Then after the cutscene skip you can do the formation menu listed below.`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`Can be done / finished anytime before Renoir 2`}<br parentName="p"></br>{`
`}{`Might be better to remove Verso until after battlefield incase you get into a battle`}</p>
      </blockquote>
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <p>{`+Maelle, -+Lune, -+Verso`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "feetress"
      }}>{`Feetress`}</h4>
      <ul>
        <li parentName="ul">{`Lune: Wildfire Fail QTE`}</li>
        <li parentName="ul">{`Verso: Skip`}</li>
      </ul>
    </Battle>
    <p>{`Pick up `}<strong parentName="p">{`Resplendant Chroma Catalyst`}</strong>{` at the end of Tainted Sanctuary or start of Tainted Battlefield.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Weakness Gain`}</strong>{`.`}</p>
    <Menu timing="Anywhere before Renoir 2" mdxType="Menu">
      <h5 {...{
        "id": "inventory-1"
      }}>{`Inventory`}</h5>
      <p>{`Equip Barrier Breaker (Go to inventory and mash confirm)`}</p>
    </Menu>
    <Menu timing="Cutscene entering Renoir 2" mdxType="Menu">
      <h5 {...{
        "id": "pictos-13"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`+(S3) Weakness Gain`}</li>
            <li parentName="ul">{`+(S2) Confident Fighter`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-2-048"
      }}>{`Renoir 2 (0:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8520, Second Chance + 3 Resplendent Chroma Catalyst`}</p>
      </blockquote>
      <p>{`Counter everything.`}</p>
      <h5 {...{
        "id": "turn-0-4"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Verso: Energy Tint Lune`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: 4 Shots, Rain of Fire (Shots are optional, recommended unless 1-2 AoE counters)`}</li>
        <li parentName="ul">{`Verso: Leadership / Skip if Lune AP >= 6`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Should die to burn tick if still alive.`}</p>
    </Battle>
    <Menu timing="At flag before Paintress" mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-5"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +15 Might (48)`}</li>
        <li parentName="ul">{`Verso: +15 Agility (15)`}</li>
      </ul>
    </Menu>
    <Menu timing="Cutscene entering Paintress battle" mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Can equip Second Chance on area transition.`}<br parentName="p"></br>{`
`}{`For Augmented First Strike, go to slot 2 and press left.`}</p>
      </blockquote>
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <p>{`-+Lune (Just jump menu for this)`}</p>
      <h5 {...{
        "id": "pictos-14"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Second Chance`}</li>
            <li parentName="ul">{`+Augmented First Strike > At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-4"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+(L2) Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "paintress-347"
      }}>{`Paintress (3:47)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8520, Painted Power, Resplendant x3`}</p>
      </blockquote>
      <p>{`Counter everything unless otherwise stated.`}</p>
      <blockquote>
        <p parentName="blockquote">{`It's possible to both over-damage and under-damage.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-5"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Offensive Switch`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Verso: Energy Tint / Skip`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
      </ul>
      <h4 {...{
        "id": "phase-2-1"
      }}>{`Phase 2`}</h4>
      <h5 {...{
        "id": "turn-25"
      }}>{`Turn 2.5`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <h4 {...{
        "id": "phase-3"
      }}>{`Phase 3`}</h4>
      <h5 {...{
        "id": "turn-45-1"
      }}>{`Turn 4.5`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Skip / Offensive Switch`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "act-3"
    }}>{`Act 3`}</h3>
    <Menu timing="Cutscene talking to Renoir" mdxType="Menu">
      <h5 {...{
        "id": "pictos-15"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`Remove Slots 1-3`}</li>
            <li parentName="ul">{`+(S3) Painted Power`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-5"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+SOS Power`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-4"
    }}>{`Camp`}</h3>
    <p>{`Load save outside `}<strong parentName="p">{`Flying Waters`}</strong>{`. Load S0 and enter Flying Waters while loading. Camp + `}<strong parentName="p">{`Debug Load`}</strong>{` is optimal.`}</p>
    <h3 {...{
      "id": "flying-waters-1"
    }}>{`Flying Waters`}</h3>
    <p>{`Exit instantly`}</p>
    <Menu timing="While jumping out of Flying Waters" mdxType="Menu">
      <h5 {...{
        "id": "formation-7"
      }}>{`Formation`}</h5>
      <p>{`-Lune, -+Maelle`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-6"
    }}>{`Continent`}</h3>
    <p>{`Fly to Lumiere`}</p>
    <h3 {...{
      "id": "lumiere"
    }}>{`Lumiere`}</h3>
    <Menu timing="Flag at start" mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-5"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Stendhal, Equip Left-Top`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-2"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Barrier Breaker +3 (18)`}</li>
      </ul>
    </Menu>
    <p>{`Fight the single Abberation.`}</p>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "abberation"
      }}>{`Abberation`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Leadership`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Battle>
    <Menu timing="Any jump" mdxType="Menu">
      <h5 {...{
        "id": "formation-8"
      }}>{`Formation`}</h5>
      <p>{`+Lune, -Verso`}</p>
    </Menu>
    <p>{`Run from Creation fight.`}</p>
    <Menu timing="Entering Renoir 3 fight" mdxType="Menu">
      <h5 {...{
        "id": "pictos-16"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Shortcut`}</li>
            <li parentName="ul">{`+Immaculate`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "renoir-3"
      }}>{`Renoir 3`}</h4>
      <p>{`Dodge all moves, only counter if Frenatically on Maelle. You can let Lune die to cut her 2nd turn.`}</p>
      <h5 {...{
        "id": "turn-0-6"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > Stendhal`}</li>
      </ul>
      <h4 {...{
        "id": "phase-2-2"
      }}>{`Phase 2`}</h4>
      <h5 {...{
        "id": "turn-05"
      }}>{`Turn 0.5`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance`}</li>
        <li parentName="ul">{`Lune: Skip if alive`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Battle>
    <p><strong parentName="p">{`Chroma Elixer`}</strong>{`, choose fight as Maelle.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "verso"
      }}>{`Verso`}</h4>
      <ul>
        <li parentName="ul">{`Last Chance > Stendhal`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "links"
    }}>{`Links`}</h3>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/MhUR2Jv_vvI?si=T2P1dlXM02oTzGGw"
      }}>{`Cardinal's Windmill`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=a5EVfG5KKVs&list=PLEdCsgJaGX6KNlVMMzIbkyy4Exq7R2voN"
      }}>{`Cardinal Playlist`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=ilRC2Te-Q04"
      }}>{`Cardinal Old Lumiere Skip`}</a><br parentName="p"></br>{`
`}<a parentName="p" {...{
        "href": "https://youtu.be/wpj4CUCesO0"
      }}>{`Password Skip`}</a></p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h5 {...{
      "id": "81426"
    }}>{`8/14/26`}</h5>
    <ul>
      <li parentName="ul">{`Added missing AFS equip before Visages`}</li>
    </ul>
    <h5 {...{
      "id": "73026"
    }}>{`7/30/26`}</h5>
    <ul>
      <li parentName="ul">{`This now uses Battlefield skip! Shoutout to Flayz for doing the routing. I've added some improvements to his changes.`}</li>
      <li parentName="ul">{`No longer pick up Staggering Attack, Gustave gets 1 Might 5 Agility at Flying Waters flag`}</li>
      <li parentName="ul">{`Esquies Nest formation menu changed, Gustave stays at front of party.`}</li>
      <li parentName="ul">{`Different pictos in SWC, Gustave gets Cleansing Tint`}</li>
      <li parentName="ul">{`Lampmaster strat updated to use intentional underdamage`}</li>
      <li parentName="ul">{`Menus changed before FB, Chalier fight changed`}</li>
      <li parentName="ul">{`Battlefield skip added`}</li>
      <li parentName="ul">{`Troubadim needs another headshot`}</li>
      <li parentName="ul">{`Lots of Picto changes, just read stuff from here I'm tired of writing :/`}</li>
    </ul>
    <h5 {...{
      "id": "62926"
    }}>{`6/29/26`}</h5>
    <ul>
      <li parentName="ul">{`Don't upgrade Gustave Might at Flying Waters`}</li>
      <li parentName="ul">{`Stagging Attack equip during Goblu Skip`}</li>
      <li parentName="ul">{`Debug load for Maellum upgrade`}</li>
      <li parentName="ul">{`Fix formation notes in Esquie's Nest`}</li>
      <li parentName="ul">{`Cut ES1 pickup`}</li>
      <li parentName="ul">{`SWC menu changed, move Staggering Attack to S2`}</li>
      <li parentName="ul">{`Act 2 start menu changed, Verso no longer gets DE2, swaps SOS Power to Maelle`}</li>
      <li parentName="ul">{`Move Maelle to back of formation in Forgotten Battlefield`}</li>
      <li parentName="ul">{`Removed menu to equip Death's Door to Verso before Monoco Station battle.`}</li>
      <li parentName="ul">{`Adjusted Visages start menu, Maelle gets Augmented FS, Verso gets Dodger Lumina`}</li>
      <li parentName="ul">{`Adjusted Joy Mask cutscene menu, clear more slots for Maelle & Verso, added formation menu.`}</li>
      <li parentName="ul">{`Teach Verso Defiant Strike before Visages`}</li>
      <li parentName="ul">{`Verso equip SOS Power lumina before Visages`}</li>
      <li parentName="ul">{`Visages different turn order and use Defiant Strike 1st turn instead of Berserk Slash`}</li>
      <li parentName="ul">{`Feetress skill menu no longer manual equip Last Chance and Leadership`}</li>
      <li parentName="ul">{`Added note about removing First Strike from Maelle for Feetress`}</li>
      <li parentName="ul">{`Renoir 2 Verso use Energy Tint T2`}</li>
      <li parentName="ul">{`Added overdamage & underdamage notes to Paintress. Added 2-3 Defiant Strike usages. P3 backup uses Offensive Switch.`}</li>
    </ul>
    <h5 {...{
      "id": "60926"
    }}>{`6/09/26`}</h5>
    <ul>
      <li parentName="ul">{`Cut Energy Tint pickup`}</li>
      <li parentName="ul">{`Don't change formation in Visages`}</li>
      <li parentName="ul">{`Move Maelle to last in formation for monolith fights`}</li>
      <li parentName="ul">{`Equip ES1 on Verso before Renoir 2`}</li>
      <li parentName="ul">{`Renoir 2 fight uses double Leadership instead of Tint + Leadership`}</li>
      <li parentName="ul">{`Paintress opening uses Swift Stride instead of Last Chance.`}</li>
      <li parentName="ul">{`Added damage notes on Paintress`}</li>
    </ul>
    <h5 {...{
      "id": "60126"
    }}>{`6/01/26`}</h5>
    <ul>
      <li parentName="ul">{`Move Augmented First Strike to SWC menu`}</li>
      <li parentName="ul">{`Add timing note for the Flying Waters debug load`}</li>
      <li parentName="ul">{`Remove debug load after Maellum, game forces a save after load breaking the setup`}</li>
      <li parentName="ul">{`Move Staggering Attack equip back to camp for the same reason.`}</li>
    </ul>
    <h5 {...{
      "id": "53126"
    }}>{`5/31/26`}</h5>
    <ul>
      <li parentName="ul">{`First draft, here's the list of changes compared to Renoir skips version`}</li>
      <li parentName="ul">{`Cut Lumina pickups`}</li>
      <li parentName="ul">{`Alt+V for Maellum 3`}</li>
      <li parentName="ul">{`Pick up Energy Tint in SWC`}</li>
      <li parentName="ul">{`Move Verso to Slot 3 in Visages`}</li>
      <li parentName="ul">{`Give Lune 6 Might at Monolith`}</li>
      <li parentName="ul">{`Teach Verso Leadership at Monolith`}</li>
      <li parentName="ul">{`Pick up Resplendant in Tainted Sanctuary end.`}</li>
      <li parentName="ul">{`Add script for Renoir 2`}</li>
      <li parentName="ul">{`Dodge Meteors on Paintress`}</li>
      <li parentName="ul">{`Act 3 "completely" different`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      